<template>
  <header class="header">
    <div class="toolbar header__toolbar bg-green">
      <div class="container">
        <div style="display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0;">
        <div class="toolbar__left" style="width: 70%;">
          <!-- balance-head / -->
          <HeaderBalance></HeaderBalance>
        </div>
        <div class="toolbar__right">
          <ul class="list-inline text-semi-bold">
            <li>
              <a href="/faq">
                <span
                  class="cap-icon cap-icon-question-circle text-transparent text-v-middle"></span>
                <span class="text-v-middle">{{ $t('Частые вопросы') }}</span>
              </a>
            </li>
            <li>
              <a href="/contacts">
                <span class="cap-icon cap-icon-headphones text-transparent text-v-middle"></span>
                <span class="text-v-middle">{{ $t('Служба поддержки') }}</span>
              </a>
            </li>
            <li>
              <HeaderLangSwitcher></HeaderLangSwitcher>
            </li>
            <li>
              <legacy-header-lang-switcher></legacy-header-lang-switcher>
            </li>
          </ul>

        </div>
        </div>
      </div>
    </div>
    <div class="nav nav_vertical-middle header__nav">
      <div class="container">
        <div class="nav__logo">
          <a class="logo-svg logo-wrapper" href="/finance" title="Capitalist.net">
            <!-- div class="logo-snowflake-cover"></div -->
            <!-- <span class="cap-color-icon-birthday-2019-baloons" style="font-size: 82px;
margin-top: -19px;
position: absolute;"><span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span><span class="path5"></span><span class="path6"></span><span class="path7"></span><span class="path8"></span><span class="path9"></span><span class="path10"></span><span class="path11"></span><span class="path12"></span><span class="path13"></span><span class="path14"></span><span class="path15"></span><span class="path16"></span><span class="path17"></span><span class="path18"></span><span class="path19"></span><span class="path20"></span><span class="path21"></span><span class="path22"></span><span class="path23"></span><span class="path24"></span><span class="path25"></span><span class="path26"></span><span class="path27"></span><span class="path28"></span><span class="path29"></span><span class="path30"></span><span class="path31"></span><span class="path32"></span><span class="path33"></span><span class="path34"></span><span class="path35"></span><span class="path36"></span><span class="path37"></span><span class="path38"></span><span class="path39"></span><span class="path40"></span><span class="path41"></span><span class="path42"></span><span class="path43"></span><span class="path44"></span><span class="path45"></span><span class="path46"></span><span class="path47"></span><span class="path48"></span><span class="path49"></span><span class="path50"></span><span class="path51"></span><span class="path52"></span></span> -->
            <i class="capitalist-icon-capitalist-logo-headed"></i>
          </a>
        </div>
<!--        <HeaderAchievements></HeaderAchievements>-->

        <div class="nav__menu nav__menu_right">
          <ul class="list-inline">
            <li>
              <div
                class="notification border-colored border-circle header-notification-has-no-replies"
                data-placement="bottom" data-toggle="tooltip"
                data-title="Система внутренних сообщений.">
                <a href="/support/issues"
                   title="Служба поддержки">
                  <span class="cap-icon cap-icon-bell-o notification__icon"></span>
                </a>
              </div>
            </li>
            <li class="nav__menu_sep"></li>
            <li>

              <div class="user-dropdown dropdown">
                <a href="" class="dropdown-trigger user-dropdown__trigger clear-link"
                   data-toggle="dropdown">
                  <div class="user-toolbar">
                    <div class="user-toolbar__avatar border-colored border-circle">
                      <div class="heading-user-avatar avatar-updatable"
                           data-avatar-update-type="header"
                           style="background-image: url(/assets/64a0e655/layout/images/ava9.png);"></div>

                    </div>
                    <div class="user-toolbar__name">
                      <span>raymanlegal</span>
                    </div>
                    <div class="user-toolbar__dropdown-trigger">
                      <span class="caret text-muted"></span>
                    </div>
                  </div>
                </a>
                <div class="dropdown-menu dropdown-menu_header user-dropdown__menu user-menu"
                     data-dropdown-in="fadeIn"
                     data-dropdown-out="fadeOut">

                  <div class="user-menu__header user-menu__section">
                    Статус: <span
                    class="text-success"><b>Верифицирован</b></span>
                  </div>
                  <div class="balance user-menu__balance user-menu__section">
                    <div class="balance__header">
                      Баланс<a href="/finance/deposit"
                               class="pull-right"><b>Пополнить счет</b></a>
                    </div>
                    <div class="balance__list">
                      <div class="currency currency_stacked balance__item">
                        <div class="currency__sign">
                          <span
                            class="cap-icon cap-icon-dollar currency__sign currency__sign_colored currency__sign_circle currency__sign_green"></span>
                        </div>
                        <div class="currency__value"><b>99 998 563 601,55</b>
                        </div>
                        <!--                                            <div class="currency__name">USD</div>-->
                      </div>
                      <div class="currency currency_stacked balance__item">
                        <div class="currency__sign">
                          <span
                            class="cap-icon cap-icon-euro currency__sign currency__sign_colored currency__sign_circle currency__sign_blue"></span>
                        </div>
                        <div class="currency__value"><b>55 072,45</b>
                        </div>
                        <!--                                            <div class="currency__name">EUR</div>-->
                      </div>

                      <div class="currency currency_stacked balance__item">
                        <div class="currency__sign">
                          <span
                            class="cap-icon cap-icon-bitcoin currency__sign currency__sign_colored currency__sign_circle currency__sign_orange"></span>
                        </div>
                        <div class="currency__value"><b>993,01049766</b>
                        </div>
                        <!--                                            <div class="currency__name">BTC</div>-->
                      </div>

                      <div class="currency currency_stacked balance__item">
                        <div class="currency__sign">
                          <span
                            class="cap-icon cap-icon-rub currency__sign currency__sign_colored currency__sign_circle currency__sign_red"></span>
                        </div>
                        <div class="currency__value"><b>1 331 543,83</b>
                        </div>
                        <!--                                            <div class="currency__name">RUR</div>-->
                      </div>

                    </div>
                  </div>
                  <div class="user-menu__actions user-menu__section">
                    <ul>
                      <li>
                        <a href="/security">Настройки безопасности</a>
                      </li>
                      <li>
                        <a href="/profile">Персональная информация</a>
                      </li>
                      <li><a href="/fees">Тарифы</a>
                      </li>
                      <li>
                        <a href="/settings/security/notifications">Центр уведомлений</a>
                      </li>
                      <li>
                        <a href="/profile/referral">Реферальная программа</a>
                      </li>
                    </ul>
                  </div>

                </div>
              </div>

            </li>
            <li class="nav__menu_sep"></li>
            <li>
              <a @click.prevent="logout" href="#" class="clear-link">
                <span class="cap-icon cap-icon-logout text-muted"></span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </header>
</template>

<script lang="ts">
// import 'bootstrap/js/dropdown';
import Vue from 'vue';
import Component from 'vue-class-component';
import HeaderLangSwitcher from '@/views/layouts/header/HeaderLangSwitcher.vue';
import HeaderBalance from '@/views/layouts/header/HeaderBalance.vue';
import LegacyHeaderLangSwitcher from "@/views/layouts/header/LegacyHeaderLangSwitcher.vue";
import HeaderAchievements from "@/views/pages/main/HeaderAchievements.vue";

@Component({
  name: 'CapHeader',
  components: {HeaderAchievements, LegacyHeaderLangSwitcher, HeaderBalance, HeaderLangSwitcher},
  methods: {
    logout() {
      this.$store.state.user.logout();
      this.$router.push('/');
    },
  },
  computed: {},
})
export default class CapHeader extends Vue {
}
</script>

<style scoped>

</style>

<i18n>
{
  "en": {
    "Частые вопросы": "Q&A",
    "Служба поддержки": "Support service"
  }
}
</i18n>
